export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('can', (el, binding, _vnode) => {
        const { authed } = useAuthStore();

        if (!authed || !binding.value) {
            return el;
        }

        if (authed?.hasPermission(binding.value)) {
            return el;
        }

        const menuVisibilityStore = useMenuVisibilityStore();

        // The menu-visibility map is fetched asynchronously on app load. While it
        // hasn't loaded yet we keep the element in the DOM: removal is irreversible
        // (the directive can't re-insert a detached node when the store resolves),
        // which is why plan-gated items used to disappear until a manual refresh.
        // The reactive upsell badge handles showing the gating state once loaded.
        if (!menuVisibilityStore.loaded) {
            return el;
        }

        const entry = menuVisibilityStore.getEntry(binding.value);
        if (entry && entry.reason === 'plan_restriction') {
            return el;
        }

        return el.parentNode?.removeChild(el);
    });
    nuxtApp.vueApp.directive('role', (el, binding, _vnode) => {
        const { authed } = useAuthStore();

        if (!authed) {
            return el;
        }

        return authed?.role === binding.value ? el : el?.parentNode?.removeChild(el);
    });
});
